export default __webpack_public_path__ + "static/media/child.f93aa193.svg";